import { DOMAINS } from '../gen/lang.js';
import { PRIVATE_ZOOPLUS_NET } from '../types.js';

const findDeploymentEnvFromHostName = (hostName) => {
    const WWW_DOMAINS = DOMAINS.map((h) => `www.${h}`);
    if (DOMAINS.includes(hostName) ||
        WWW_DOMAINS.includes(hostName) ||
        hostName.endsWith('k8sp.int.aws.zooplus.io') ||
        (hostName.endsWith(PRIVATE_ZOOPLUS_NET) &&
            !hostName.endsWith(`dev.${PRIVATE_ZOOPLUS_NET}`) &&
            !hostName.endsWith(`release.${PRIVATE_ZOOPLUS_NET}`) &&
            !hostName.endsWith(`beta.${PRIVATE_ZOOPLUS_NET}`))) {
        return 'prod';
    }
    if (hostName.startsWith('test.')) {
        return 'test';
    }
    switch (hostName) {
        case hostName.match(/local/)?.input:
            return 'local';
        case hostName.match(/release/)?.input:
            return 'release';
        case hostName.match(/beta-www/)?.input:
            return 'beta';
        default:
            return 'dev';
    }
};

export { findDeploymentEnvFromHostName };
//# sourceMappingURL=serverEnvService.js.map
